/* 趙雲傳・第 2 章：桂陽・辭樊氏（建安十四年前後，209）
 * 史實：《先主傳》「先主表琦為荊州刺史，又南征四郡。武陵太守金旋、長沙太守韓玄、桂陽太守趙範、零陵太守劉度皆降。」
 *       《趙雲傳》注引《雲別傳》「從平江南，以為偏將軍，領桂陽太守，代趙範。範寡嫂曰樊氏，有國色，範欲以配雲。
 *       雲辭曰：『相與同姓，卿兄猶我兄。』固辭不許。時有人勸雲納之，雲曰：『範迫降耳，心未可測；天下女不少。』
 *       遂不取。範果逃走，雲無纖介。」
 *       （演義第 52 回「趙子龍計取桂陽」的陳應、鮑隆，以及趙範以樊氏設計，都只放外傳。）
 * 流程：1. 西門受降。2. 巡視城外三處鄉里（遊戲的安排：交代新太守到任）。
 *       3. 郡府宴上趙範提親：走到「固辭」或「納之」站定來選；有人再勸，再選一次。納之就不是史實——這一章輸。
 *       4. 夜裡趙範從東門逃走，城中驚擾：到府庫、市、東門三處安定人心（驚擾滿了就輸）。追出城去也追不到什麼——雲無纖介。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, rout, vanish } from '../kit.ts';
import { CITY, WGATE, EGATE, FU, KU, SHI, START, XIANG } from '../maps/zhaoyun_guiyang.ts';
import { MEN, GUI, band, npc, choose, chooseTick } from './zhaoyun_kit.ts';

const LV = 12, CALM = 60;
const inCity = (u) => Math.abs(u.x - CITY.x) < CITY.hw && Math.abs(u.y - CITY.y) < CITY.hh;
const SAY = [
  [['鄉老', '新來的府君是常山趙將軍？聽說他在當陽懷抱幼主、殺出重圍。'], ['趙雲', '雲奉左將軍之命領桂陽。鄉里但安心耕作。']],
  [['鄉民', '趙府君雖然降了，他的部曲還帶著兵器在城裡進出……'], ['趙雲', '知道了。']],
  [['鄉老', '去年兵荒馬亂，田都荒了。'], ['趙雲', '今年的賦稅，雲替你們請減。']],
];

export default {
  id: 'zhaoyun-2', map: 'zhaoyun_guiyang', hero: 'zhaoyun',
  title: '第 3 章　桂陽', year: '建安十四年（209）',
  gold: 0, // 不打仗的一章
  brief: {
    quote: [{ text: '相與同姓，卿兄猶我兄。', src: '《趙雲傳》注引《雲別傳》' }, { text: '範迫降耳，心未可測；天下女不少。', src: '《趙雲傳》注引《雲別傳》' }],
    text: '赤壁之後，劉備南征武陵、長沙、桂陽、零陵四郡，四郡太守都投降了。趙雲以偏將軍領桂陽太守，接替投降的趙範。',
    goals: ['西門受降', '巡視鄉里', '郡府赴宴', '夜裡安定城中'],
  },
  words: { ally: '趙雲部', foe: '—' },
  stars: [
    { text: '沒有追出城去（雲無纖介）', ok: (m) => !m.vars.chased },
    { text: '驚擾始終不到六成', ok: (m) => m.vars.panicMax < 60 },
    { text: `${CALM} 秒內安定全城`, ok: (m) => m.vars.calmT <= CALM },
  ],
  steps: [
    { // 1. 西門受降
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.men = band(m, me, 8, '趙雲部');
        V.fan = npc(w, MEN.zhaofan, WGATE[0] - 180, WGATE[1], { name: '趙範', ms: 200 });
        V.qu = Array.from({ length: 5 }, (_, i) => npc(w, GUI, WGATE[0] - 120 + (i % 3) * 60, WGATE[1] + (i < 3 ? -110 : 110), { name: '趙範部曲', ms: 200 }));
        m.card('初，先主之敗，有人言雲已北去者，先主以手戟擿之曰：「子龍不棄我走也。」頃之，雲至。', '《雲別傳》（裴注）');
        m.after(5, () => m.line('旁白', '長坂之後，赤壁一戰，曹操北還。劉備南征荊南四郡。'));
        m.after(9, () => m.line('趙雲', '桂陽太守趙範已經請降。進城。'));
        m.mark('fan', V.fan.x, V.fan.y, '趙範', false, V.fan);
        m.obj('gate', '到西門受降');
      },
      tick(m, w) { return m.near(w.player, m.vars.fan.x, m.vars.fan.y, 260); },
    },
    { // 2. 巡視鄉里
      enter(m, w) {
        const V = m.vars;
        m.done('gate'); m.unmark('fan');
        m.line('趙範', '桂陽太守趙範，率郡中吏民歸降。印綬在此。');
        m.card('桂陽太守趙範……皆降。', '《先主傳》');
        m.after(4, () => m.card('從平江南，以為偏將軍，領桂陽太守，代趙範。', '《雲別傳》（裴注）'));
        V.fan.home = [FU[0] + 120, FU[1] + 60];
        V.qu.forEach((u, i) => { u.home = [FU[0] - 200 + i * 90, FU[1] + 200]; });
        V.xiang = XIANG.map(([x, y], k) => { m.mark('x' + k, x, y, '鄉里', true); for (let i = 0; i < 3; i++) m.folk(x + (i - 1) * 70, y + 60, { name: '百姓', look: (k + i) % 4 }); return { x, y, done: false }; });
        for (let i = 0; i < 6; i++) m.folk(CITY.x - 500 + i * 200, CITY.y + 150, { name: '城中百姓', look: i % 4 });
        m.after(7, () => m.line('提示', '到城外三處鄉里站定，安撫百姓。'));
        m.obj('xiang', '巡視城外三處鄉里', 3);
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.xiang.forEach((s, k) => {
          if (s.done) return;
          m.chanAt(me, 'x' + k, s.x, s.y, 220, 2, '安撫', () => {
            s.done = true; m.unmark('x' + k);
            SAY[k].forEach((L, j) => m.after(j * 3, () => m.line(L[0], L[1])));
            m.prog('xiang', V.xiang.filter((o) => o.done).length);
          });
        });
        return V.xiang.every((s) => s.done);
      },
    },
    { // 3. 郡府赴宴
      enter(m, w) {
        m.done('xiang');
        m.after(6, () => { m.mark('fu', FU[0], FU[1], '郡府'); m.obj('fu', '回郡府赴趙範的宴'); m.line('趙範', '府君巡郡辛苦，範在府中備了酒宴。'); });
      },
      tick(m, w) { return !!m.get('fu') && m.near(w.player, FU[0], FU[1], 240); },
    },
    { // 4. 提親：選兩次
      enter(m, w) {
        const V = m.vars;
        m.done('fu'); m.unmark('fu');
        const at = (dx, dy) => SG.MAP.nearestFree(FU[0] + dx, FU[1] + dy);
        m.line('趙範', '範有寡嫂樊氏，國色也。願以配將軍。');
        m.after(3.5, () => m.line('提示', '走到「固辭」或「納之」站定來選。'));
        V.p1 = at(-230, 230); V.p2 = at(230, 230); V.p3 = at(-230, 470); V.p4 = at(230, 470);
        m.obj('pick', '趙範要把寡嫂樊氏許配給你');
        const second = () => {
          m.line('趙雲', '相與同姓，卿兄猶我兄。');
          m.after(3, () => m.line('旁人', '樊氏國色，將軍何不納之？'));
          m.after(5, () => choose(m, w, [{ key: 'no2', label: '天下女不少', x: V.p4[0], y: V.p4[1] }, { key: 'yes2', label: '納之', x: V.p3[0], y: V.p3[1] }], (k) => {
            if (k === 'yes2') { V.took = true; m.lose('趙雲納了樊氏。史實是「遂不取」——範迫降耳，心未可測'); return; }
            m.line('趙雲', '範迫降耳，心未可測；天下女不少。'); V.refused = true;
          }));
        };
        m.after(1, () => choose(m, w, [{ key: 'no', label: '固辭', x: V.p1[0], y: V.p1[1] }, { key: 'yes', label: '納之', x: V.p2[0], y: V.p2[1] }], (k) => {
          if (k === 'yes') { V.took = true; m.lose('趙雲納了樊氏。史實是「固辭不許」'); return; }
          second();
        }));
      },
      tick(m, w) { chooseTick(m, w); return !!m.vars.refused; },
    },
    { // 5. 範果逃走：安定城中
      enter(m, w) {
        const V = m.vars;
        m.done('pick');
        m.card('遂不取。', '《雲別傳》（裴注）');
        m.after(4, () => {
          m.big('夜半');
          m.line('郡吏', '府君！趙範帶著部曲，開東門走了！城裡人心惶惶！');
          V.fan.home = [7900, 2300]; V.fan.ms = 240;
          V.qu.forEach((u, i) => { u.home = [7800, 2200 + i * 50]; u.ms = 240; });
          V.spots = [[KU, '府庫'], [SHI, '市'], [EGATE, '東門']].map(([p, name], k) => { const q = k === 2 ? [p[0] - 120, p[1]] : p; m.mark('s' + k, q[0], q[1], name, true); return { x: q[0], y: q[1], name, done: false }; });
          V.panic = 20; V.panicMax = 20; V.t5 = w.t;
          m.obj('calm', '');
          m.after(3, () => m.line('提示', '到府庫、市、東門站定安定人心；驚擾滿了城就亂了。'));
        });
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        for (const u of [V.fan, ...V.qu]) if (u.alive && u.x > 7500) vanish(w, u);
        if (!V.spots) return false;
        V.spots.forEach((s, k) => {
          if (s.done) return;
          m.chanAt(me, 's' + k, s.x, s.y, 170, 2.5, '安定', () => { s.done = true; m.unmark('s' + k); V.panic = Math.max(0, V.panic - 25); m.line('趙雲', ['府庫封好，一物不許動。', '各回家去，城中無事。', '關上東門，不必追了。'][k]); });
        });
        const left = V.spots.filter((s) => !s.done).length;
        if (me.x > EGATE[0] + 400 && !V.chased) { V.chased = true; m.line('郡吏', '府君，城裡更亂了！'); }
        V.panic += dt * 0.6 * left * (inCity(me) ? 1 : 2);
        V.panicMax = Math.max(V.panicMax, V.panic);
        m.get('calm').text = `安定城中（驚擾 ${Math.round(Math.min(100, V.panic))}%，還有 ${left} 處）`;
        if (V.panic >= 100) { m.lose('城中大亂'); return false; }
        if (!left) { V.calmT = w.t - V.t5; return true; }
        return false;
      },
    },
    { // 6. 雲無纖介
      enter(m, w) {
        m.done('calm');
        m.card('範果逃走，雲無纖介。', '《雲別傳》（裴注）');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) m.lose('趙雲陣亡');
  },
};
